var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-filter"},[_c('BigSelect',{attrs:{"items":_vm.categories},on:{"change":_vm.categoryChanged},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }